import { useState } from './use-state.js';
export function useRef(val) {
    return useState({ current: val })[0];
}
